export const colors = {
  brandPrimaryDefault: "#d70a0a",
  brandPrimaryTint: "#ed8e8e",
  brandPrimaryShade: "#5a0404",
  brandSecondaryDefault: "#089B80",
  brandSecondaryTint: "#b1ebe0",
  brandSecondaryShade: "#002A2A",
  brandGradientDefault: "linear-gradient(125deg, #0a0a0a 0%, #990707 100%)",
  brandGradientColorStopsStart: "#0a0a0a",
  brandGradientColorStopsEnd: "#990707",
  productColorsPrimaryL5: "#fbe7e7",
  productColorsPrimaryL4: "#f3b3b3",
  productColorsPrimaryL3: "#ed8e8e",
  productColorsPrimaryL2: "#e45b5b",
  productColorsPrimaryL1: "#df3b3b",
  productColorsPrimary: "#d70a0a",
  productColorsPrimaryD1: "#c40909",
  productColorsPrimaryD2: "#990707",
  productColorsPrimaryD3: "#5a0404",
  productColorsPrimaryD4: "#2D0202",
  productColorsSecondaryL5: "#E6F8F5",
  productColorsSecondaryL4: "#b1ebe0",
  productColorsSecondaryL3: "#55D3BD",
  productColorsSecondaryL2: "#06D6AE",
  productColorsSecondaryL1: "#02BD9C",
  productColorsSecondary: "#089B80",
  productColorsSecondaryD1: "#01866F",
  productColorsSecondaryD2: "#016856",
  productColorsSecondaryD3: "#014F42",
  productColorsSecondaryD4: "#002A2A",
  contentStrong: "#ffffff",
  contentDefault: "#CED4DB",
  contentSubtle: "#969DA3",
  contentDisabled: "#ffffff33",
  contentOnLight: "#0a0a0a",
  contentBrandPrimary: "#d70a0a",
  contentBrandSecondary: "#b1ebe0",
  contentLoadingDefault: "#ffffff0d",
  contentLoadingInverse: "#0a0a0a0d",
  contentLink: "#00C898",
  contentLinkActive: "#00E5B4",
  backgroundBase: "#1C1D1D",
  backgroundSurface: "#0a0a0a",
  backgroundLayer: "#2B2D2E",
  backgroundAccent: "#ffffff0d",
  backgroundHover: "#3C3E40",
  backgroundActive: "#02BD9C",
  backgroundDisabled: "#3C3E40",
  backgroundTransparent: "#0a0a0a00",
  backgroundSecondary: "#0a0a0a",
  backgroundPromotional: "#0a0a0a",
  backgroundBrand: "#d70a0a",
  backgroundGradientSurfaceFadeEnd: "linear-gradient(90deg, #0a0a0a00 0%, #0a0a0a 100%)",
  backgroundGradientSurfaceFadeBottom: "linear-gradient(180deg, #0a0a0a00 0%, #0a0a0a 100%)",
  backgroundGradientColorStopsStart: "#0a0a0a00",
  backgroundGradientColorStopsEnd: "#0a0a0a",
  borderDefault: "#6A6F73",
  borderSubtle: "#3C3E40",
  borderActive: "#02BD9C",
  borderDisabled: "#ffffff1a",
  borderInverse: "#EAF0F6",
  borderBrand: "#d70a0a",
  linkDefaultBase: "#00C898",
  linkDefaultHover: "#00E5B4",
  linkDestructiveBase: "#EA6875",
  linkDestructiveHover: "#D22839",
  linkInverseDefaultHover: "#9CF7E4",
  systemInfoBackgroundDefault: "#004EA3",
  systemInfoBackgroundSubtle: "#002650",
  systemInfoBorderDefault: "#004EA3",
  systemInfoContentOnSubtle: "#ffffff",
  systemInfoContentAccent: "#99CAFF",
  systemInfoLinkOnSubtle: "#ffffff",
  systemPositiveBackgroundDefault: "#005D23",
  systemPositiveBackgroundSubtle: "#002E11",
  systemPositiveBorderDefault: "#005D23",
  systemPositiveContentOnSubtle: "#ffffff",
  systemPositiveContentAccent: "#7FD9A1",
  systemPositiveLinkOnSubtle: "#ffffff",
  systemAlertBackgroundDefault: "#756100",
  systemAlertBackgroundSubtle: "#4B3F00",
  systemAlertBorderDefault: "#756100",
  systemAlertContentOnDefault: "#ffffff",
  systemAlertContentOnSubtle: "#ffffff",
  systemAlertContentAccent: "#FFDC2E",
  systemAlertLinkOnDefault: "#ffffff",
  systemAlertLinkOnSubtle: "#ffffff",
  systemWarningBackgroundDefault: "#A44800",
  systemWarningBackgroundSubtle: "#692E00",
  systemWarningBorderDefault: "#A44800",
  systemWarningContentOnDefault: "#ffffff",
  systemWarningContentOnSubtle: "#ffffff",
  systemWarningContentAccent: "#FFB77E",
  systemWarningLinkOnDefault: "#ffffff",
  systemWarningLinkOnSubtle: "#ffffff",
  systemImportantBackgroundDefault: "#A40023",
  systemImportantBackgroundSubtle: "#40020D",
  systemImportantBorderDefault: "#A40023",
  systemImportantContentOnSubtle: "#ffffff",
  systemImportantContentAccent: "#F198A1",
  systemImportantLinkOnSubtle: "#ffffff",
  systemNeutralBackgroundDefault: "#6A6F73",
  systemNeutralBackgroundSubtle: "#3C3E40",
  systemNeutralBorderDefault: "#6A6F73",
  systemNeutralContentOnDefault: "#ffffff",
  systemNeutralContentOnSubtle: "#ffffff",
  systemNeutralContentAccent: "#CED4DB",
  systemNeutralLinkOnDefault: "#ffffff",
  systemNeutralLinkOnSubtle: "#ffffff",
  systemVerificationBackgroundDefault: "#61019B",
  systemVerificationBackgroundSubtle: "#36005B",
  systemVerificationBorderDefault: "#61019B",
  systemVerificationContentOnSubtle: "#ffffff",
  systemVerificationContentAccent: "#D4B6FE",
  systemVerificationLinkOnSubtle: "#ffffff",
  componentButtonPrimaryContentBase: "#0a0a0a",
  componentButtonPrimaryContentHover: "#0a0a0a",
  componentButtonPrimaryContentActive: "#0a0a0a",
  componentButtonPrimaryContentDisabled: "#0a0a0a80",
  componentButtonPrimaryBackgroundBase: "#02BD9C",
  componentButtonPrimaryBackgroundHover: "#06D6AE",
  componentButtonPrimaryBackgroundActive: "#089B80",
  componentButtonPrimaryBackgroundDisabled: "#3C3E40",
  componentButtonPrimaryBorderBase: "#02BD9C",
  componentButtonPrimaryBorderHover: "#06D6AE",
  componentButtonPrimaryBorderActive: "#089B80",
  componentButtonPrimaryBorderDisabled: "#ffffff1a",
  componentButtonSecondaryContentDisabled: "#ffffff33",
  componentButtonSecondaryBackgroundBase: "#0a0a0a00",
  componentButtonSecondaryBackgroundHover: "#ffffff33",
  componentButtonSecondaryBackgroundActive: "#ffffff66",
  componentButtonSecondaryBackgroundDisabled: "#0a0a0a00",
  componentButtonSecondaryBorderBase: "#ffffff",
  componentButtonSecondaryBorderHover: "#ffffff",
  componentButtonSecondaryBorderActive: "#ffffff",
  componentButtonSecondaryBorderDisabled: "#ffffff1a",
  componentButtonTertiaryContentBase: "#02BD9C",
  componentButtonTertiaryContentHover: "#06D6AE",
  componentButtonTertiaryContentActive: "#089B80",
  componentButtonTertiaryContentDisabled: "#ffffff33",
  componentButtonTertiaryBackgroundBase: "#0a0a0a00",
  componentButtonTertiaryBackgroundHover: "#0a0a0a00",
  componentButtonTertiaryBackgroundActive: "#0a0a0a00",
  componentButtonTertiaryBackgroundDisabled: "#0a0a0a00",
  componentButtonTertiaryBorderBase: "#0a0a0a00",
  componentButtonTertiaryBorderHover: "#0a0a0a00",
  componentButtonTertiaryBorderActive: "#0a0a0a00",
  componentButtonTertiaryBorderDisabled: "#0a0a0a00",
  componentButtonTransparentBackgroundBase: "#0a0a0a00",
  componentButtonTransparentBackgroundHover: "#ffffff33",
  componentButtonTransparentBackgroundActive: "#089B80",
  componentButtonTransparentBackgroundDisabled: "#0a0a0a00",
  componentButtonTransparentBorderActive: "#0a0a0a00",
  componentButtonDestructiveContentDisabled: "#0a0a0a80",
  componentButtonDestructiveBackgroundHover: "#A40023",
  componentButtonDestructiveBackgroundActive: "#83001C",
  componentButtonDestructiveBackgroundDisabled: "#3C3E40",
  componentButtonDestructiveBorderHover: "#A40023",
  componentButtonDestructiveBorderActive: "#83001C",
  componentButtonDestructiveBorderDisabled: "#ffffff1a",
  componentButtonButtonLinkContentBase: "#02BD9C",
  componentButtonButtonLinkContentHover: "#06D6AE",
  componentButtonButtonLinkContentActive: "#089B80",
  componentButtonButtonLinkContentDisabled: "#ffffff33",
  componentButtonButtonLinkBackgroundBase: "#0a0a0a00",
  componentButtonButtonLinkBackgroundHover: "#0a0a0a00",
  componentButtonButtonLinkBackgroundActive: "#0a0a0a00",
  componentButtonButtonLinkBackgroundDisabled: "#0a0a0a00",
  componentButtonButtonLinkBorderBase: "#0a0a0a00",
  componentButtonButtonLinkBorderHover: "#0a0a0a00",
  componentButtonButtonLinkBorderActive: "#0a0a0a00",
  componentButtonButtonLinkBorderDisabled: "#0a0a0a00",
  componentSelectionControlBackgroundBase: "#0a0a0a",
  componentSelectionControlBackgroundHover: "#0a0a0a",
  componentSelectionControlBackgroundActive: "#02BD9C",
  componentSelectionControlBackgroundSelected: "#02BD9C",
  componentSelectionControlBackgroundSelectedHover: "#02BD9C",
  componentSelectionControlBackgroundSelectedActive: "#02BD9C",
  componentSelectionControlBackgroundUnselected: "#4D5153",
  componentSelectionControlBackgroundDisabled: "#3C3E40",
  componentSelectionControlBackgroundSuccess: "#31C268",
  componentSelectionControlBackgroundError: "#EA6875",
  componentSelectionControlBorderBase: "#6A6F73",
  componentSelectionControlBorderHover: "#ffffff",
  componentSelectionControlBorderActive: "#ffffff",
  componentSelectionControlBorderSelected: "#02BD9C",
  componentSelectionControlBorderSelectedHover: "#02BD9C",
  componentSelectionControlBorderSelectedActive: "#ffffff",
  componentSelectionControlBorderUnselected: "#4D5153",
  componentSelectionControlBorderDisabled: "#ffffff1a",
  componentSelectionControlBorderSuccess: "#1BB152",
  componentSelectionControlBorderError: "#EB4758",
  componentSelectionControlForegroundBase: "#0a0a0a00",
  componentSelectionControlForegroundHover: "#0a0a0a00",
  componentSelectionControlForegroundActive: "#0a0a0a00",
  componentSelectionControlForegroundSelected: "#0a0a0a",
  componentSelectionControlForegroundSelectedHover: "#0a0a0a",
  componentSelectionControlForegroundSelectedActive: "#0a0a0a",
  componentSelectionControlForegroundUnselected: "#0a0a0a00",
  componentSelectionControlForegroundDisabled: "#ffffff33",
  componentSelectionControlForegroundSuccess: "#0a0a0a",
  componentSelectionControlForegroundError: "#0a0a0a",
  componentDataInputBackgroundBase: "#0a0a0a",
  componentDataInputBackgroundLayer: "#2B2D2E",
  componentDataInputBackgroundHover: "#3C3E40",
  componentDataInputBackgroundError: "#40020D",
  componentDataInputBackgroundDisabled: "#3C3E40",
  componentDataInputBorderBase: "#6A6F73",
  componentDataInputBorderActive: "#004EA3",
  componentDataInputBorderError: "#A40023",
  componentDataInputBorderDisabled: "#ffffff1a",
  componentDataInputContentBase: "#CED4DB",
  componentDataInputContentSubtle: "#969DA3",
  componentDataInputContentHover: "#99CAFF",
  componentDataInputContentError: "#F198A1",
  componentDataInputContentDisabled: "#ffffff33",
  componentDataInputLabelBase: "#ffffff",
  componentDataInputLabelActive: "#99CAFF",
  componentDataInputLabelError: "#F198A1",
  componentDataInputLabelDisabled: "#ffffff33",
  componentDataInputPasswordMeterEmpty: "#6A6F73",
  componentDataInputPasswordMeterWeak: "#A40023",
  componentDataInputPasswordMeterFair: "#A44800",
  componentDataInputPasswordMeterGood: "#004EA3",
  componentDataInputPasswordMeterGreat: "#005D23",
  componentDataInputIconBase: "#969DA3",
  componentDataInputIconActive: "#99CAFF",
  componentDataInputIconError: "#F198A1",
  componentDataInputIconDisabled: "#ffffff33",
  componentPillPrimaryContentBase: "#ffffff",
  componentPillPrimaryContentHover: "#ffffff",
  componentPillPrimaryContentDisabled: "#0a0a0a",
  componentPillPrimaryBackgroundBase: "#ffffff1a",
  componentPillPrimaryBackgroundHover: "#ffffff4d",
  componentPillPrimaryBackgroundSelected: "#d70a0a",
  componentPillPrimaryBackgroundActive: "#df3b3b",
  componentPillPrimaryBackgroundDisabled: "#2B2D2E",
  componentPillInverseContentHover: "#ffffff",
  componentPillInverseContentDisabled: "#0a0a0a",
  componentPillInverseBackgroundBase: "#0a0a0a00",
  componentPillInverseBackgroundHover: "#ffffff4d",
  componentPillInverseBackgroundSelected: "#d70a0a",
  componentPillInverseBackgroundActive: "#df3b3b",
  componentPillInverseBackgroundDisabled: "#2B2D2E",
  componentTabPrimaryLabelBase: "#ffffff",
  componentTabPrimaryLabelHover: "#ffffff",
  componentTabPrimaryLabelActive: "#ffffff",
  componentTabPrimaryDescriptionBase: "#CED4DB",
  componentTabPrimaryDescriptionHover: "#CED4DB",
  componentTabPrimaryDescriptionActive: "#CED4DB",
  componentTabPrimaryIndicatorBase: "#0a0a0a00",
  componentTabPrimaryIndicatorHover: "#df3b3b",
  componentTabPrimaryIndicatorActive: "#d70a0a",
  componentTabPrimaryBackgroundBase: "#0a0a0a00",
  componentTabPrimaryBackgroundHover: "#0a0a0a00",
  componentTabPrimaryBackgroundActive: "#0a0a0a00",
  componentTabPrimaryIconBase: "#ffffff",
  componentTabPrimaryIconHover: "#ffffff",
  componentTabPrimaryIconActive: "#ffffff",
  componentTabInverseIndicatorBase: "#0a0a0a00",
  componentTabInverseIndicatorHover: "#EAF0F6",
  componentTabInverseIndicatorActive: "#EAF0F6",
  componentTabInverseBackgroundBase: "#0a0a0a00",
  componentTabInverseBackgroundHover: "#0a0a0a00",
  componentTabInverseBackgroundActive: "#0a0a0a00",
};

export const text = {
  themeName: "Poker",
};

export const radii = {
  componentButtonCornerRadius: 9999,
  componentCardCornerRadius: 8,
};